import { render, staticRenderFns } from "./Teen6.vue?vue&type=template&id=53686867&scoped=true&"
import script from "./Teen6.vue?vue&type=script&lang=js&"
export * from "./Teen6.vue?vue&type=script&lang=js&"
import style0 from "./Teen6.vue?vue&type=style&index=0&id=53686867&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53686867",
  null
  
)

export default component.exports